import { Component, OnInit } from '@angular/core';
import { anyGlobal, AssetsGenerateUrlService, AssetUIModel, ClientNotificationHandlerService, ConfigObjectModel } from '@thehubz/client/core';
import { AssetsApiService } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'thehubz-asset-dashboard-view',
  templateUrl: './asset-dashboard-view.component.html',
  styleUrls: ['./asset-dashboard-view.component.scss'],
})
export class AssetDashboardViewComponent implements OnInit {
  assetsData: AssetUIModel[] = [];

  basketDataLoaded = false;
  configObject: ConfigObjectModel = {
    title: $localize`Popular assets`,
    callFrom: 'dashboard',
  };
  filterObject = {
    filters: {
      assetId: '',
      search: '',
    },
    sort: { createdAt: -1 },
  };
  /**
   * True when data is loading from server
   */
  httpCallInProgress = false;

  AnyGlobal = anyGlobal;

  constructor(
    private assetService: AssetsApiService,
    private clientNotificationHandlerService: ClientNotificationHandlerService,
    private assetUrlService: AssetsGenerateUrlService,
  ) {}

  ngOnInit(): void {
    // resigning empty string because search value assigned at parent component (collection.component.ts)
    this._showLoader();
    this.fetchAssetsData();
  }

  /**
   * get all collection list of logged in user
   * @param searchText
   */
  fetchAssetsData(): Promise<AnyType> {
    return new Promise((resolve, reject) => {
      this.assetService
        .assetsControllerFindMostPopularAssets()
        .pipe(tap(() => this._showLoader(false)))
        .subscribe({
          next: async (response) => {
            const formattedResponseData: AssetUIModel[] = [];
            if (response.length > 0) {
              response.forEach((assetObject: AnyType) => {
                formattedResponseData.push(assetObject.asset);
              });
            }
            const responseData = this.assetUrlService.generatePreview(formattedResponseData ?? []);
            this.assetsData = [...responseData] as AssetUIModel[];
            this.basketDataLoaded = true;
          },
          error: (err) => {
            this.basketDataLoaded = true;
            this.clientNotificationHandlerService.errorNotification(err);
            reject(err);
          },
        });
    });
  }

  /**
   * Utility method to show/hide loader
   */
  private _showLoader(show = true) {
    this.httpCallInProgress = show;
  }
}
